import { render } from "./ResultVue.vue?vue&type=template&id=09ca4106&scoped=true"
import script from "./ResultVue.vue?vue&type=script&lang=js"
export * from "./ResultVue.vue?vue&type=script&lang=js"

import "./ResultVue.vue?vue&type=style&index=0&id=09ca4106&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ca4106"]])

export default __exports__